<template>
    <div class="modal fade" id="unidade_delete_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Deletar</b>
                        </h5>
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            Deseja realmente DELETAR o(a) <b>{{ delete_unidade.nome }}</b>?
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger"
                            @click.prevent.stop="deleteUnidade">
                            Deletar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';

    export default {

    	components: {
            Dot
        },


    	data(){
            return {
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],

                //OBJECTS
                delete_unidade: {}
            }
        },

        mounted(){
        	this.registryEventOpenModalDeleteUnidade();
        },

        methods: {
            registryEventOpenModalDeleteUnidade(){
                eventBus.$on('eventOpenModalDeleteUnidade', (deleteUnidade, currentPage) => {
                	this.errors = [];
                    this.delete_unidade = Object.assign({}, deleteUnidade);
                    this.currentPagePagination = currentPage;
                    $("#unidade_delete_modal").modal("show");
                });
            },

            emitEventGetUnidades(){
                eventBus.$emit('eventGetUnidades', this.currentPagePagination);
            },

            deleteUnidade()
            {
                this.isLoading = true;
                axios.delete(
                    '/unidade/' + this.delete_unidade.id
                )
                .then(response => {
                    this.isLoading = false;
                    $("#unidade_delete_modal").modal("hide");
                    toastr.success(response.data.message);
                    this.emitEventGetUnidades();
                })
                .catch(error => {
                    this.isLoading = false;
                    let erroObject = error.response.data;
                    if(erroObject.message)
                    {
                        toastr.error(erroObject.message);
                    }
                });
            }

            
            
        }
    }
</script>